import { render, staticRenderFns } from "./plan-boxes.vue?vue&type=template&id=5890b196"
import script from "./plan-boxes.vue?vue&type=script&lang=js"
export * from "./plan-boxes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports